import { render, staticRenderFns } from "./admin_ynzx.vue?vue&type=template&id=89be6724&scoped=true"
import script from "./admin_ynzx.vue?vue&type=script&lang=js"
export * from "./admin_ynzx.vue?vue&type=script&lang=js"
import style0 from "./admin_ynzx.vue?vue&type=style&index=0&id=89be6724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89be6724",
  null
  
)

export default component.exports